import { createContext, useContext } from 'react';

type TooltipContextType = {
  setBlocking: (isBlocked: boolean) => void;
  disabled?: boolean;
};

const NOOP = () => {};

const DEFAULT: TooltipContextType = {
  setBlocking: NOOP,
  disabled: false,
};

const TooltipContext = createContext<TooltipContextType>(DEFAULT);

export const TooltipProvider = TooltipContext.Provider;
export const useTooltipContext = () => useContext(TooltipContext);
